@if (errorMessage) {
  <ngb-alert class="content spacing remove-close-button" type="danger" dismissible="false">
    <pre [innerHTML]="errorMessage" (dblclick)="toggle()"></pre>
    @if (show) {
      <pre [innerText]="errorStringified"></pre>
    }
  </ngb-alert>
}
